module.exports = __webpack_public_path__ + "img/google.8bba39fd.png";